import { createFileRoute, Navigate } from '@tanstack/react-router';

/** Default sports landing redirects to Football for now. */
export const Route = createFileRoute('/sports/')({
  component: () => <Navigate to="/sports/$sport" params={{ sport: 'football' }} />,
});
